import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionResponseCreateInput } from '../generated/globalTypes';
import { createQuestionResponseMutation, createQuestionResponseMutationVariables } from '../generated/createQuestionResponseMutation';
import { questionResponseFieldsFragment } from '../models/QuestionResponse';

/**
 * Get a callback to create a QuestionResponse in the store.
 */
export function useCreateQuestionResponseCallback(): [(model: QuestionResponseCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createQuestionResponseMutation, createQuestionResponseMutationVariables>(
        gql`
            mutation createQuestionResponseMutation ($model: QuestionResponseCreateInput!) {
                createQuestionResponse(model: $model) {
                    ...questionResponseFields
                }
            }

            ${questionResponseFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: QuestionResponseCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
